<ng-container *ngIf="sharedService.isLoggedIn() && !isPdfPage">
  <!-- Chat Bubble -->
  <div
    class="chat-bubble"
    (mousedown)="startDrag($event)"
    [ngStyle]="{
      'bottom.px': bubblePosition.bottom,
      'right.px': bubblePosition.right,
      position: 'fixed'
    }"
    data-testid="chat-bubble"
  >
    <img
      src="assets/icons/solbox-ai-stars.png"
      alt="AURA Icon"
      width="45"
      height="45"
      style="pointer-events: none"
      data-testid="chat-bubble-icon"
    />
  </div>

  <!-- ChatBox Window -->
  <div
    class="chatbox-window"
    *ngIf="chatBoxOpen"
    data-testid="chatbox-window"
    [ngStyle]="{
      width: chatboxSize.width + 'px',
      height: chatboxSize.height + 'px',
      bottom: windowPosition.bottom + 'px',
      right: windowPosition.right + 'px'
    }"
  >
    <div class="chatbox-header" data-testid="chatbox-header">
      <div data-testid="chatbox-mode-switch">
        <span class="mode-label">{{ 'ask' | titlecase }}</span>
        <label class="switch">
          <input
            type="checkbox"
            [(ngModel)]="isActionMode"
            (change)="toggleMode()"
            data-testid="chatbox-mode-checkbox"
          />
          <span class="slider" data-testid="chatbox-mode-slider"></span>
        </label>
        <span class="mode-label">{{ 'action' | titlecase }}</span>
      </div>
      <button
        mat-icon-button
        (click)="closeChatBox()"
        data-testid="chatbox-close-btn"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="chatbox-intro" data-testid="chatbox-intro">
      <h3>Welcome to AURA AI (Beta)!</h3>
    </div>

    <div
      id="chatbox-messages"
      class="chatbox-messages"
      #chatMessagesContainer
      data-testid="chatbox-messages"
    >
      <span *ngIf="isLoadingChatHistory" class="text-with-spinner">
        Loading Chat History... <mat-spinner [diameter]="20"></mat-spinner>
      </span>

      <div class="bot">
        <div class="chat-message">
          <p>Hi, I'm AURA, your AI operations agent.</p>
          <p>
            I'm currently in Ask Anything mode, I can also be put to work by
            flipping the switch above to Action mode.
          </p>
          <p>
            In Ask mode you can ask me how to do anything on SolBox and I will
            provide you with answers.
          </p>
          <p>
            In Action mode I can perform functions in SolBox. To find out what
            actions I can perform, in action mode, you can say “what actions can
            I do?”
          </p>
          <p>How can I assist you today?</p>
        </div>
      </div>

      <ng-container *ngIf="!isLoadingChatHistory">
        <button
          *ngIf="hasOlderMessages"
          type="button"
          class="load-older-btn"
          (click)="loadOlderMessages()"
          data-testid="chatbox-load-older"
        >
          Load older messages
        </button>
        <div
          *ngFor="
            let msg of visibleMessages;
            trackBy: trackByMessage;
            let i = index
          "
          [ngClass]="msg.from"
          [attr.id]="'msg-' + i"
          data-testid="chatbox-message"
        >
          <div
            class="chat-message"
            [innerHTML]="msg.text | markdownSafe"
            data-testid="chatbox-message-text"
          ></div>
          <div
            *ngIf="
              msg.sources?.length &&
              !msg.text?.toLowerCase().startsWith('unfortunately')
            "
            data-testid="chatbox-message-sources"
          >
            <span>Sources:</span>
            <div *ngFor="let source of msg.sources" style="margin-bottom: 4px">
              <a
                [href]="source.url"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="chatbox-message-source-link"
              >
                {{ source.title }}
              </a>
            </div>
          </div>

          <div
            *ngIf="msg.requiresConfirmation"
            class="confirmation-buttons"
            data-testid="chatbox-confirmation-buttons"
          >
            <button
              mat-raised-button
              (click)="handleConfirmation(true)"
              data-testid="chatbox-confirm-yes"
            >
              Yes
            </button>
            <button
              mat-raised-button
              (click)="handleConfirmation(false)"
              data-testid="chatbox-confirm-no"
            >
              No
            </button>
          </div>
        </div>
      </ng-container>
    </div>
    <!-- Message input area -->
    <div class="chatbox-input-row" data-testid="chatbox-input-row">
      <input
        type="text"
        [(ngModel)]="chatMessage"
        placeholder="Type your message..."
        (keydown.enter)="sendMessage()"
        class="chatbox-input"
        data-testid="chatbox-input"
      />
      <button
        mat-icon-button
        class="send-btn"
        (click)="sendMessage()"
        [disabled]="!chatMessage?.trim() || isLoadingChatHistory"
        data-testid="chatbox-send-btn"
      >
        <mat-icon>arrow_upward</mat-icon>
      </button>
    </div>

    <div
      class="resize-handle resize-handle-top"
      role="button"
      tabindex="0"
      aria-label="Resize chatbox from top"
      (mousedown)="startResize($event, 'top')"
    ></div>
    <div
      class="resize-handle resize-handle-left"
      role="button"
      tabindex="0"
      aria-label="Resize chatbox from left"
      (mousedown)="startResize($event, 'left')"
    ></div>
    <div
      class="resize-handle resize-handle-corner"
      role="button"
      tabindex="0"
      aria-label="Resize chatbox from corner"
      (mousedown)="startResize($event, 'corner')"
    ></div>
  </div>
</ng-container>
